import { defineMessages } from '../define';

/** The sign-in screen and the routes that land somewhere that does not exist. */
export const auth = defineMessages({
  en: {
    'auth.signIn': 'Sign in',
    'auth.signingIn': 'Signing in',
    'auth.subtitle': 'Use the account an administrator created for you.',
    'auth.email': 'Email',
    'auth.password': 'Password',
    'auth.totp': 'Authentication code',
    'auth.totpRequired': 'This account uses two-factor authentication. Enter the code from your app.',
    'auth.offline': 'Cannot reach the gateway. Check that the API is running, then try again.',
    'auth.version': 'Threadline console {version}',

    'auth.tagline': 'An operations console for the LINE accounts your team runs.',
    'auth.feature.sessions': 'Sessions',
    'auth.feature.sessions.detail': 'One browser per LINE account, watched around the clock',
    'auth.feature.messages': 'Messages',
    'auth.feature.messages.detail': 'Captured, searchable and exportable across every session',
    'auth.feature.webhooks': 'Webhooks',
    'auth.feature.webhooks.detail': 'Signed, retried and replayable from the delivery log',

    'auth.notFound.title': 'That page does not exist',
    'auth.notFound.description':
      'The link may be out of date, or the item it pointed at has been deleted.',
    'auth.notFound.back': 'Back to the overview',
  },
  th: {
    'auth.signIn': 'เข้าสู่ระบบ',
    'auth.signingIn': 'กำลังเข้าสู่ระบบ',
    'auth.subtitle': 'ใช้บัญชีที่ผู้ดูแลระบบสร้างไว้ให้คุณ',
    'auth.email': 'อีเมล',
    'auth.password': 'รหัสผ่าน',
    'auth.totp': 'รหัสยืนยันตัวตน',
    'auth.totpRequired': 'บัญชีนี้เปิดใช้การยืนยันตัวตนสองขั้นตอน กรุณากรอกรหัสจากแอปของคุณ',
    'auth.offline': 'เชื่อมต่อเกตเวย์ไม่ได้ กรุณาตรวจสอบว่า API ทำงานอยู่ แล้วลองใหม่อีกครั้ง',
    'auth.version': 'คอนโซล Threadline {version}',

    'auth.tagline': 'คอนโซลสำหรับดูแลบัญชี LINE ที่ทีมของคุณใช้งานอยู่',
    'auth.feature.sessions': 'เซสชัน',
    'auth.feature.sessions.detail': 'หนึ่งเบราว์เซอร์ต่อหนึ่งบัญชี LINE เฝ้าดูตลอด 24 ชั่วโมง',
    'auth.feature.messages': 'ข้อความ',
    'auth.feature.messages.detail': 'เก็บไว้ ค้นหาได้ และส่งออกได้จากทุกเซสชัน',
    'auth.feature.webhooks': 'Webhooks',
    'auth.feature.webhooks.detail': 'ลงลายเซ็น ส่งซ้ำ และเรียกส่งใหม่ได้จากบันทึกการส่ง',

    'auth.notFound.title': 'ไม่พบหน้านี้',
    'auth.notFound.description': 'ลิงก์อาจล้าสมัยแล้ว หรือรายการที่ลิงก์ชี้ไปถูกลบไปแล้ว',
    'auth.notFound.back': 'กลับไปหน้าภาพรวม',
  },
});
